var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlagSweden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.0938C18 13.8023 17.0513 15.1875 15.1875 15.1875H2.8125C0.948656 15.1875 0 13.8023 0 12.0938V5.90625C0 4.19766 0.948656 2.8125 2.8125 2.8125H15.1875C17.0513 2.8125 18 4.19766 18 5.90625V12.0938Z",
    fill: "#1B75BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 2.8125H8.15625V15.1875H5.625V2.8125Z",
    fill: "#FDC40C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.59375H18V9.84375H0V7.59375Z",
    fill: "#FDC40C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSweden);
export default __webpack_public_path__ + "static/media/flag-sweden.db98377ab3c4f1b29739034a0e319f7a.svg";
export { ForwardRef as ReactComponent };